import React from 'react';

const sections = [
  {
    title: '1. Scope of This Privacy Policy',
    content: `This Policy applies to:

• Website visitors
• Software development clients
• Staffing & recruitment candidates
• BPO service users
• Business partners, vendors, and suppliers
• Individuals communicating with EGB Systems via email, phone, or forms`,
  },
  {
    title: '2. Information We Collect',
    content: `A. Personal Information
Depending on the service, we may collect:

• Name, email address, phone number
• Company name, job title
• Address and communication details
• Resume, job application data (for staffing services)
• Identification documents (where legally required)

B. Technical Information

• IP address and device information
• Browser type and operating system
• Usage analytics and interaction data
• Cookies and tracking data

C. Project or Service-Related Data
For software development and BPO services, we may collect:

• Technical documentation
• Project requirements
• System credentials provided by the client
• Data processed as part of outsourced or support activities`,
  },
  {
    title: '3. How We Use Your Information',
    content: `We use your information to:

• Provide and improve software development services
• Process job applications and staffing assignments
• Support BPO operations and service delivery
• Communicate regarding projects, support, and inquiries
• Maintain internal records and client accounts
• Ensure network and information security
• Comply with legal and regulatory obligations

We do not sell or rent your personal information.`,
  },
  {
    title: '3A. WhatsApp Messaging & Data Usage',
    content: `Kallos360 uses WhatsApp Business APIs to enable client businesses to send transactional, notification, and promotional messages to their customers using their own WhatsApp Business numbers and approved message templates.

Message-related data such as delivery status, read receipts, template information, and message content may be processed solely for the purpose of providing messaging services, reports, and customer communication management.

EGB Systems & Solutions Inc. does not sell, rent, or misuse WhatsApp message data and processes such data strictly on behalf of client businesses, in compliance with applicable laws and Meta (Facebook / WhatsApp) Platform Policies.`,
  },
  {
    title: '4. Legal Basis for Processing',
    content: `Where required by law, we rely on:

• Your consent
• Contractual necessity
• Legitimate business interests
• Compliance with legal obligations`,
  },
  {
    title: '5. Information Sharing & Disclosure',
    content: `We may share information with:

• Authorized internal staff
• Third-party service providers (hosting, analytics, payment processors, background checks)
• Government or regulatory authorities when required by law
• Clients, only for staffing-related placement or verification
• Partners under Non-Disclosure Agreements (NDAs)

All third-party partners are required to maintain confidentiality and security.`,
  },
  {
    title: '6. Data Security',
    content: `We use industry-standard security practices, including:

• Encryption of sensitive data
• Access control and authentication
• Regular system monitoring
• Secure data storage
• Employee confidentiality agreements

However, no system is completely secure, and we cannot guarantee absolute protection.`,
  },
  {
    title: '7. Data Retention',
    content: `We retain your information only as long as necessary to:

• Deliver contracted services
• Fulfill legal, tax, or compliance obligations
• Support ongoing recruitment and staffing processes
• Maintain business records

You may request deletion of your information where applicable.`,
  },
  {
    title: '8. Your Rights',
    content: `You may have the right to:

• Access and request a copy of your data
• Correct inaccurate information
• Request deletion of your data
• Withdraw consent
• Object to or restrict processing
• Request transfer of your data

To exercise these rights, contact us at support@egbsystems.com`,
  },
  {
    title: '9. Cookies & Tracking',
    content: `Our website may use cookies and analytics tools to:

• Improve user experience
• Understand website usage
• Customize content and marketing

You can disable cookies through your browser settings.`,
  },
  {
    title: '10. Third-Party Links',
    content: `Our website may contain external links. We are not responsible for the privacy practices of third-party sites.`,
  },
  {
    title: '11. International Data Transfers',
    content: `In providing services, your information may be processed in countries where EGB Systems or its partners operate. We ensure adequate protection through contractual and technical safeguards.`,
  },
  {
    title: "12. Children's Privacy",
    content: `Our services are not intended for individuals under 16 years of age, and we do not knowingly collect data from minors.`,
  },
  {
    title: '13. Updates to This Policy',
    content: `We may update this Privacy Policy from time to time. Updates will be posted on our website with a revised "Last Updated" date.`,
  },
];

const PrivacyPolicy = () => (
  <>
    <section className="py-5 text-white text-center" style={{ background: 'linear-gradient(135deg, #002868, #1a56db)' }}>
      <div className="container py-4">
        <h1 className="fw-bold">Privacy Policy</h1>
        <p className="lead" style={{ color: '#cbd5e1' }}>Last Updated: November 19, 2025</p>
      </div>
    </section>

    <section className="py-5 bg-light">
      <div className="container py-4">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-9">

            {/* Intro */}
            <div className="card border-0 shadow-sm p-4 p-md-5 rounded-4 mb-4">
              <h5 className="fw-bold mb-3" style={{ color: '#1a56db' }}>EGB Systems & Solutions Inc.</h5>
              <p className="text-muted mb-0" style={{ lineHeight: 1.9 }}>
                EGB Systems & Solutions Inc. is committed to protecting your personal information and ensuring transparency
                in how we collect, use, and safeguard data. This Privacy Policy explains how we handle information when
                you visit our website, engage with our Software Development, Staffing, and Business Process Outsourcing
                (BPO) services, or contact us.
              </p>
            </div>

            {/* Sections */}
            {sections.map((s, i) => (
              <div key={i} className="card border-0 shadow-sm p-4 p-md-5 rounded-4 mb-4">
                <h5 className="fw-bold mb-3" style={{ color: '#1a56db' }}>{s.title}</h5>
                <p className="text-muted mb-0" style={{ lineHeight: 1.9, whiteSpace: 'pre-line' }}>{s.content}</p>
              </div>
            ))}

            {/* Contact */}
            <div className="card border-0 shadow-sm p-4 p-md-5 rounded-4 mb-4">
              <h5 className="fw-bold mb-3" style={{ color: '#1a56db' }}>Contact Information</h5>
              <p className="text-muted mb-0" style={{ lineHeight: 2 }}>
                <strong>EGB Systems & Solutions Inc.</strong><br />
                Address: 1010 Summer Street, Suite 102, 1st Floor, Stamford, Connecticut 06905<br />
                Phone: 203-653-2741<br />
                Fax: 866-693-5396<br />
                Email: <a href="mailto:support@egbsystems.com" className="text-primary">support@egbsystems.com</a><br />
                Website: <a href="https://www.egbsystems.com" target="_blank" rel="noopener noreferrer" className="text-primary">https://www.egbsystems.com</a>
              </p>
            </div>

          </div>
        </div>
      </div>
    </section>
  </>
);

export default PrivacyPolicy;
